import React, { useState, useEffect } from 'react'
import { Typography, Grid, makeStyles } from '@material-ui/core'

import CrossMark from '../../../../../Assets/Images/icons/crossMark'
import { ShopifyLogo } from '../../../../../Assets/Images/logos/ShopifyLogo'

import { stylesShopify } from './stylesShopify'

const useStyles = makeStyles(() => stylesShopify)

const BannerShopify = ({
  id = 'shopify-banner',
  cypress_ids,
  description,
  action,
  isShow,
}) => {
  const classes = useStyles()
  const loginSessionID = JSON.stringify(localStorage.apiKey)
  const [show, setShow] = useState(isShow)

  useEffect(() => {
    const bannerState = localStorage.getItem(id)
    if (bannerState === loginSessionID) {
      setShow(false)
    }
  }, [id, loginSessionID])

  const handleClose = () => {
    setShow(!show)
    localStorage.setItem(id, loginSessionID)
  }

  return show ? (
    <Grid
      container
      className={classes.container}
      cypress_id={cypress_ids.container}
    >
      {/* Text content section */}
      <Grid
        item
        xs={12}
        className={classes.contentWrapper}
        onClick={action.onClick}
      >
        <div className={classes.textContainer}>
          <Typography cypress_id={cypress_ids.title} className={classes.title}>
            Connect your{' '}
            <ShopifyLogo width="128" height="40" className="shopifyLogo" />{' '}
            store
          </Typography>
          <Typography
            cypress_id={cypress_ids.description}
            className={classes.description}
          >
            {description}
          </Typography>
        </div>

        {/* Button section */}
        <div className={classes.buttonContainer}>
          <button className={classes.button} cypress_id={cypress_ids.button}>
            <ShopifyLogo
              width="67"
              height="20"
              variant="white"
              style={{ marginTop: -2 }}
            />
            {action.button}
          </button>
        </div>
      </Grid>

      {/* Close button */}
      <span className={classes.closeBtn} cypress_id={cypress_ids.close}>
        <CrossMark
          width="24"
          height="24"
          stroke="#292D32"
          className={classes.crossMark}
          onClick={handleClose}
        />
      </span>
    </Grid>
  ) : null
}

export default BannerShopify
